import { assertNotNullish, } from '@synapex/tools/typescript';
function getWd(ws) {
    if (ws.workspace_type === 'site') {
        return {
            workspace_type: 'site',
            workspace_id: ws.site_id,
        };
    }
    else {
        return {
            workspace_type: 'channel',
            workspace_id: ws.channel_id,
        };
    }
}
function getByType(ws, getters) {
    if (ws.workspace_type === 'site') {
        //@ts-expect-error generic
        return getters.site(ws);
    }
    else {
        //@ts-expect-error generic
        return getters.channel(ws);
    }
}
function pickWd({ workspace_id, workspace_type }) {
    return { workspace_id, workspace_type };
}
function extractWd({ workspace_id, workspace_type, ...rest }) {
    return [
        {
            workspace_id,
            workspace_type,
        },
        rest,
    ];
}
function getWdFromSnake(snakeIdObj) {
    if (typeof snakeIdObj.site_id === 'number') {
        return {
            workspace_type: 'site',
            workspace_id: snakeIdObj.site_id,
        };
    }
    else if (typeof snakeIdObj.channel_id === 'number') {
        return {
            workspace_type: 'channel',
            workspace_id: snakeIdObj.channel_id,
        };
    }
    return null;
}
function getWdFromSnakeOrThrow(snakeIdObj) {
    const r = getWdFromSnake(snakeIdObj);
    assertNotNullish(r, `getWdFromSnakeOrThrow: ${JSON.stringify(snakeIdObj)}`);
    return r;
}
function getWdFromCamel(camelIdObj) {
    if (typeof camelIdObj.siteId === 'number') {
        return {
            workspace_type: 'site',
            workspace_id: camelIdObj.siteId,
        };
    }
    else if (typeof camelIdObj.channelId === 'number') {
        return {
            workspace_type: 'channel',
            workspace_id: camelIdObj.channelId,
        };
    }
    return null;
}
function getWdFromCamelOrThrow(camelIdObj) {
    const r = getWdFromCamel(camelIdObj);
    assertNotNullish(r, `getWdFromCamelOrThrow: ${JSON.stringify(camelIdObj)}`);
    return r;
}
function getCamelFromWd(wd) {
    if (wd.workspace_type === 'site') {
        return {
            siteId: wd.workspace_id,
        };
    }
    else {
        return {
            channelId: wd.workspace_id,
        };
    }
}
function getSnakeFromWd(wd) {
    if (wd.workspace_type === 'site') {
        return {
            site_id: wd.workspace_id,
        };
    }
    else {
        return {
            channel_id: wd.workspace_id,
        };
    }
}
const fromPrismaSite = (site) => {
    return {
        ...site,
        workspace_type: 'site',
    };
};
const fromPrismaChannel = (channel) => {
    return {
        ...channel,
        workspace_type: 'channel',
    };
};
const fromPrismaOrThrow = (input) => {
    const r = fromPrisma(input);
    if (r) {
        return r;
    }
    throw new Error(`fromPrismaOrThrow: ${JSON.stringify(input)}`);
};
const fromPrisma = (input) => {
    if (input.site) {
        return {
            workspace_type: 'site',
            ...input.site,
        };
    }
    else if (input.channel) {
        return {
            workspace_type: 'channel',
            ...input.channel,
        };
    }
    return null;
};
const isSame = (a, b) => {
    if (a.workspace_type === 'site' &&
        b.workspace_type === 'site' &&
        ('workspace_id' in a ? a.workspace_id : a.site_id) === b.site_id) {
        return true;
    }
    if (a.workspace_type === 'channel' &&
        b.workspace_type === 'channel' &&
        ('workspace_id' in a ? a.workspace_id : a.channel_id) === b.channel_id) {
        return true;
    }
    return false;
};
const isEqualWd = (a, b) => {
    return (a.workspace_type === b.workspace_type && a.workspace_id === b.workspace_id);
};
function isWorkspaceType(v) {
    return v === 'site' || v === 'channel';
}
export const recordByWdGet = (record, wd) => {
    return record[wd.workspace_type][wd.workspace_id];
};
export const recordByWdSet = (record, wd, p) => {
    record[wd.workspace_type][wd.workspace_id] = p;
};
export const recordByWdDelete = (record, wd) => {
    delete record[wd.workspace_type][wd.workspace_id];
};
const pickBriefChannel = ({ channel_id, channel_name, channel_username, telegram_channel_id, telegram_channel_invite_hash, }) => ({
    workspace_type: 'channel',
    channel_id,
    channel_name,
    channel_username,
    telegram_channel_id,
    telegram_channel_invite_hash,
});
const pickBriefSite = ({ site_id, hostname, pathname }) => ({
    workspace_type: 'site',
    site_id,
    hostname,
    pathname,
});
const pickBrief = (ws) => {
    if (ws.workspace_type === 'channel') {
        return pickBriefChannel(ws);
    }
    else {
        return pickBriefSite(ws);
    }
};
export const workspaceMethods = {
    fromPrismaSite,
    fromPrismaChannel,
    getWd,
    pickWd,
    extractWd,
    getWdFromSnake,
    getWdFromSnakeOrThrow,
    getWdFromCamel,
    getWdFromCamelOrThrow,
    getCamelFromWd,
    getSnakeFromWd,
    fromPrismaOrThrow,
    fromPrisma,
    isSame,
    isEqualWd,
    getByType,
    isWorkspaceType,
    pickBriefChannel,
    pickBriefSite,
    pickBrief,
};
//# sourceMappingURL=workspace.js.map